import { render, staticRenderFns } from "./AssignCaregiverModal.vue?vue&type=template&id=613cb2ed&scoped=true&"
import script from "./AssignCaregiverModal.vue?vue&type=script&lang=js&"
export * from "./AssignCaregiverModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignCaregiverModal.vue?vue&type=style&index=0&id=613cb2ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613cb2ed",
  null
  
)

export default component.exports